import React, { useEffect, useState } from "react";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { RHFSelect } from "../../../Shared/RHFSelect";
import { Speed } from "@mui/icons-material";
import { getWeight, getWeightLabel } from "../../constants";

const Ranking = ({ control, hfControl, watch }) => {
  const [rank, setRank] = useState(0);
  const priority = watch("priority");
  const consider = watch("consider");
  const frequency = watch("frequency");

  useEffect(() => {
    const project = { consider, priority, frequency };
    setRank(getWeight(project));
  }, [priority, consider, frequency]);

  const rankLabel = getWeightLabel(rank);
  const rankColor = rank >= 8 ? "#c62828" : rank >= 5 ? "#e65100" : rank >= 3 ? "#1565c0" : "#2e7d32";

  return (
    <Box>
      {/* Rank Badge */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
        <Speed color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Priority & Weight
        </Typography>
        <Chip
          label={`${rankLabel} (${rank})`}
          sx={{
            ml: "auto",
            fontWeight: 700,
            fontSize: 16,
            px: 2,
            py: 2.5,
            bgcolor: rankColor,
            color: "#fff",
          }}
        />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <RHFSelect
            fullWidth
            name="consider"
            label="Urgency"
            id="consider"
            {...hfControl}
            options={[
              { label: "Low", value: 1 },
              { label: "Medium", value: 2 },
              { label: "High", value: 3 },
              { label: "Critical", value: 4 },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RHFSelect
            fullWidth
            name="priority"
            label="Impact Scope"
            id="priority"
            {...hfControl}
            options={[
              { label: "Individual / Flat(s)", value: 1 },
              { label: "Block", value: 2 },
              { label: "Community-wide", value: 3 },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RHFSelect
            fullWidth
            name="frequency"
            label="Recurrence"
            id="frequency"
            {...hfControl}
            options={[
              { label: "One-time", value: 1 },
              { label: "Periodic (few times/year)", value: 2 },
              { label: "Monthly", value: 3 },
              { label: "Ongoing", value: 4 },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Ranking;
